var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-row justify-between items-center"},[_c('div',[_c('h2',{staticClass:"capitalize mb-0"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._t("header-action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }